module.exports = __webpack_public_path__ + "static/media/icon-todo.aaa2137a.svg";